import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  extractDataFromObject,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
} from '../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  create_post_data,
  showErrorMessage,
  showSuccessMessage,
  extractDataFromObject,
  API_URL,
  createSearchUrl,
};

export const PATIENT_ENCOUNTERS_DETAILS_API = `${API_URL}/patient-encounter/GetPatientNonBillableEncounterDetails`;
export const GET_APPOINTMENT_DATA_API = `${API_URL}/api/PatientAppointments/GetAppointmentDetails`;
export const SAVE_PATIENTENCOUNTER_API = `${API_URL}/patient-encounter/SavePatientNonBillableEncounter`;
export const SAVE_CLOCKIN_TIME_API = `${API_URL}/api/PatientAppointments/SaveClockInTimeIntoAppointment`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const SAVE_CLOCKOUT_TIME_API = `${API_URL}/api/PatientAppointments/SaveClockOutTimeIntoAppointment`;
export const GET_PATIENT_NON_BILLABLE_ENCOUNTER_DETAILS = `${API_URL}/patient-encounter/GetPatientNonBillableEncounterDetails`;
export const SAVE_PATIENT_NON_BILLABLE_ENCOUNTER_DETAILS = `${API_URL}/patient-encounter/SavePatientNonBillableEncounter`;

export const soapActionTypes = {
  get_appointment_by_id: createRequestActionTypes('NON_BILLABLE_GET_APPOINTMENT'),
  post_patient_encounter: createRequestActionTypes('NON_BILLABLE_POST_PATIENT_ENCOUNTER'),
  get_patient_encounter: createRequestActionTypes('NON_BILLABLE_GET_PATIENT_ENCOUNTER'),
  post_clockin_time: createRequestActionTypes('POST_CLOCKIN_TIME_API'),
  get_masterdata: createRequestActionTypes('GET_SOAP_MASTERSDATA'),
  post_clockout_time: createRequestActionTypes('POST_CLOCKOUT_TIME_API'),
  get_patient_non_billable_encounter: createRequestActionTypes('GET_PATIENT_NON_BILLABLE_ENCOUNTER'),
  save_patient_non_billable_encounter: createRequestActionTypes("SAVE_PATIENT_NON_BILLABLE_ENCOUNTER"),
};




// WEBPACK FOOTER //
// ./src/modules/scheduling/components/nonBillableSoap/constants/ApiConstants.js